import { useState } from "react";
import PropTypes from "prop-types";
import { useAuth } from "../lib/AuthContext";

export default function LoginForm({ onSuccess = () => {} }) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        if (!username || !password) return;
        setLoading(true);
        try {
            const data = await login(username, password);
            onSuccess(data);
        } catch (err) {
            setError(err?.message || "Invalid credentials");
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-2" data-testid="login-form">
            <div className="flex flex-col">
                <label htmlFor="username" className="text-xs">Username</label>
                <input
                    id="username"
                    name="username"
                    type="text"
                    autoComplete="username"
                    required
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="text-black px-1 rounded"
                />
            </div>
            <div className="flex flex-col">
                <label htmlFor="password" className="text-xs">Password</label>
                <input
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="text-black px-1 rounded"
                />
            </div>
            {error && <div className="text-xs text-red-400">{error}</div>}
            <button type="submit" className="underline" disabled={loading}>
                {loading ? "Signing in..." : "Sign In"}
            </button>
        </form>
    );
}

LoginForm.propTypes = {
    onSuccess: PropTypes.func,
};

